import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@material-ui/core'
import { LocalizedButton } from 'components/Localization/LocalizedButton'
import { QuantityString } from 'model/Quantity'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import {
  CategoryDto,
  CategoryRowDto,
} from '../../../../services/APIs/InternalAPI/internal-api.contracts'
import './FormDetails.sass'

interface Props {
  formDetails: CategoryDto[]
}

const FormDetails = (props: Props) => {
  const [activeTab, setActiveTab] = React.useState(undefined)
  const [activeDetails, setActiveDetails] = React.useState<
    CategoryRowDto[] | undefined
  >(undefined)
  const { t } = useTranslation('project')

  React.useEffect(() => {
    if (props.formDetails) {
      const category = props.formDetails.find((x) => x.label === activeTab)
      const details = (category && category.details) || undefined
      setActiveDetails(details)
    }

    if (!activeTab && props.formDetails) {
      setActiveDetails(props.formDetails)
      setActiveTab(props.formDetails[0]?.label)
    }
  }, [activeTab, props.formDetails])

  if (!props.formDetails?.length) return null

  return (
    <div className="form-details">
      <div className="form-details--container">
        <div className="form-details-categories">
          <div className="form-details-categories-container">
            <ul>
              {props.formDetails.map((category) => {
                return (
                  <li key={category.label}>
                    <LocalizedButton
                      translationKey={`project:${category.label}`}
                      variant={
                        activeTab === category.label ? 'outlined' : 'text'
                      }
                      disableElevation
                      disableFocusRipple
                      disableRipple
                      className={activeTab === category.label ? 'active' : ''}
                      color={
                        activeTab === category.label ? 'primary' : 'default'
                      }
                      onClick={() => {
                        if (activeTab === category.label) return
                        setActiveDetails(undefined)
                        setActiveTab(category.label)
                      }}
                    />
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
        <div className="form-details--data">
          {activeDetails && (
            <TableContainer>
              <Table size="small">
                <TableBody>
                  {activeDetails.map((x, i) => (
                    <TableRow key={i}>
                      <TableCell component="th" scope="row">
                        {t(`project:${x.label}`, x.label)}
                      </TableCell>
                      <TableCell align="right">
                        {QuantityString(x.quantity)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </div>
      </div>
    </div>
  )
}

export { FormDetails }
